import { action } from "satcheljs";
import type { Module } from "owa-workloads-module";
import type React from "react";
import type { MailboxInfo } from "owa-client-types";

export interface OnModuleClickActionMessage {
    module: Module;
    currentlySelectedModule: Module | undefined;
    activeModuleAction: ((ev?: React.MouseEvent<unknown, MouseEvent> | React.KeyboardEvent<HTMLElement> | undefined) => void) | undefined;
    mailboxInfo: MailboxInfo | undefined;
}

const defaultExport: (module: Module, currentlySelectedModule?: Module, activeModuleAction?: (ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>) => void, mailboxInfo?: MailboxInfo) => OnModuleClickActionMessage = action("onModuleClick", (module: Module, currentlySelectedModule?: Module, activeModuleAction?: (ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>) => void, mailboxInfo?: MailboxInfo): OnModuleClickActionMessage => ({
    module,
    currentlySelectedModule,
    activeModuleAction,
    mailboxInfo,
}));
export default defaultExport;
